import { Card, CardBody } from "./../../components/card/card.jsx";
import { useNavigate, useParams } from "react-router-dom";
import { CardHeader, ProgressBar } from "react-bootstrap";
import { useEffect, useState } from "react";
import DateTimeFormat from "../../components/dateFormater/dateFormat2.js";
import EditTitle from "./EditModals/editTitle.jsx";
import EditLocation from "./EditModals/editLocation.jsx";
import EditInstitution from "./EditModals/editInstitution.jsx";
import EditStartDate from "./EditModals/editStartDate.jsx";
import EditEndDate from "./EditModals/editEndDate.jsx";
import ModalHelp from "../../components/modal/modalHelp.jsx";
import { dataTel1DeleteEvt, dataTel1EditMain, dataTel1EvtRes, dataTel1ExtraTime } from "../../config/apiSPA.js";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
function Tel1Detail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({ status: false, content: {} });
  const [modalConfirmEventDelete, setModalConfirmEventDelete] = useState({ show: false, title: "Warning", text: "no text", id: null });
  function getVariant(val) {
    if (val <= 2) return "danger";
    if (val <= 4) return "warning";
    if (val <= 5) return "success";
    if (val <= 6) return "info";
  }
  const loadData = (val) => {
    setData((a) => ({ ...a, content: val }));
  };
  const hanldelDeleteEvent = () => setModalConfirmEventDelete({ show: true, title: "Warning", text: "Are you sure delete this mentoring data ?", id: null });
  const handleDeleteEventConfirmed = () => {
    setModalConfirmEventDelete((a) => ({ ...a, show: false }));
    dataTel1DeleteEvt(id).then((res) => navigate(`/training-evaluation/event`));
  };
  useEffect(() => {
    dataTel1EvtRes(id).then((res) => {
      if (res.status === "true") setData({ status: true, content: res.content });
    });
  }, []);
  return (
    <>
      <div>
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">TRAINING EVALUASI</a>
          </li>
          <li className="breadcrumb-item active">Detail</li>
        </ul>

        <h1 className="page-header">
          Training Evaluasi Level 1 Result <small></small>
        </h1>

        <hr className="mb-4" />
        {data.status ? (
          <div className="row gx-4">
            <div className="col-lg-6">
              <Card className="mb-4">
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">General</CardHeader>
                <CardBody>
                  <GeneralItem dataItem={data.content} reloadData={loadData} />
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-6">
              <Card className="mb-4">
                <CardHeader className="d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
                  <div className="flex-1">
                    <div>Resume</div>
                  </div>
                </CardHeader>
                <CardBody>
                  <ResumeItem data={data.content} />
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-12">
              <Card className="mb-4">
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Participant</CardHeader>
                <CardBody>
                  <div className="table-responsive">
                    <table className="table table-hover text-nowrap">
                      <thead>
                        <tr>
                          <th className="border-top-0 pt-0 pb-2">No.</th>
                          <th className="border-top-0 pt-0 pb-2">Name</th>
                          <th className="border-top-0 pt-0 pb-2">Program</th>
                          <th className="border-top-0 pt-0 pb-2">Tool</th>
                          <th className="border-top-0 pt-0 pb-2">Fasilitator</th>
                          <th className="border-top-0 pt-0 pb-2">Overall</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.content.participant.length > 0 ? (
                          data.content.participant.map((val, index) => (
                            <tr key={index}>
                              <td className="align-middle">{index + 1}</td>
                              <td className="align-middle">{val.name === "-" ? "Participant " + (index + 1) : val.name}</td>
                              <td className="align-middle">
                                <ProgressBar label={val.result.program.toFixed(2)} now={val.result.program} variant={getVariant(val.result.program)} min={0} max={6} />
                              </td>
                              <td className="align-middle">
                                <ProgressBar label={val.result.tool.toFixed(2)} now={val.result.tool} variant={getVariant(val.result.tool)} min={0} max={6} />
                              </td>
                              <td className="align-middle">
                                <ProgressBar label={val.result.fasilitators.toFixed(2)} now={val.result.fasilitators} variant={getVariant(val.result.fasilitators)} min={0} max={6} />
                              </td>
                              <td className="align-middle">
                                <ProgressBar label={val.result.overAll.toFixed(2)} now={val.result.overAll} variant={getVariant(val.result.overAll)} min={0} max={6} />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td>No Data</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-12">
              <SubjectiveResume data={data.content} />
            </div>
            <a href="#/" onClick={hanldelDeleteEvent} className="text-danger">
              Delete
            </a>
          </div>
        ) : (
          <p>Loading.....</p>
        )}
      </div>
      <ModalConfirm
        show={modalConfirmEventDelete.show}
        clicked={() => handleDeleteEventConfirmed()}
        onHide={() => setModalConfirmEventDelete({ ...modalConfirmEventDelete, show: false })}
        title={modalConfirmEventDelete.title}
        text={modalConfirmEventDelete.text}
        theme={"danger"}
      />
    </>
  );
}
export default Tel1Detail;

function SubjectiveResume({ data }) {
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Subjective</CardHeader>
        <CardBody>
          <div className="d-flex mb-3">
            <div className="flex-1 d-flex">
              <div>
                <div>Komentar Secara Keseluruhan</div>
                {data.resume.subjective.overallComment.length > 0
                  ? data.resume.subjective.overallComment.map((val, index) => (
                      <div key={index} className="mb-3">
                        <div className="d-flex mt-1 text-opacity-50 small">
                          <div>
                            <i className="fa fa-circle text-warning fs-6px d-block mt-2"></i>
                          </div>
                          <div className="flex-1 ps-2">
                            <div className="text-theme">{val.text}</div>
                          </div>
                        </div>
                        {val.result.length > 0 ? (
                          val.result.map((item, ind) => (
                            <div key={ind} className="d-flex mt-1 text-inverse text-opacity-50 small">
                              <div className="flex-1 ps-3">
                                <div>{item}</div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <>No Data</>
                        )}
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
          <div className="d-flex">
            <div className="flex-1 d-flex">
              <div>
                <div>Lain-lain</div>
                {data.resume.subjective.otherComment.length > 0
                  ? data.resume.subjective.otherComment.map((val, index) => (
                      <div key={index} className="mb-3">
                        <div className="d-flex mt-1 text-opacity-50 small">
                          <div>
                            <i className="fa fa-circle text-warning fs-6px d-block mt-2"></i>
                          </div>
                          <div className="flex-1 ps-2">
                            <div className="text-theme">{val.text}</div>
                          </div>
                        </div>
                        {val.result.length > 0 ? (
                          val.result.map((item, ind) => (
                            <>
                              <div key={ind} className="d-flex mt-1 text-inverse text-opacity-50 small">
                                <div className="flex-1 ps-3">
                                  <div>{item}</div>
                                </div>
                              </div>
                            </>
                          ))
                        ) : (
                          <>No Data</>
                        )}
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}

function ResumeItem({ data }) {
  return (
    <>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex px-3">
          <div className="me-3 pt-1">
            <i className="far fa-check-circle text-success fa-fw fa-lg"></i>
          </div>
          <div className="flex-fill">
            <div className="fw-400">General Resume</div>
            <div className="small text-inverse text-opacity-50 mb-2">By Average Each items</div>

            <div className="d-flex align-items-center mb-2">
              <div className="fw-400 me-2">Instructor</div>
              <div className="progress progress-xs w-100px me-2 ms-auto" style={{ height: "10px" }}>
                <div className="progress-bar progress-bar-striped bg-success" style={{ width: (data.resume.objective.fasilitator / 6) * 100 + "%" }}></div>
              </div>
              <div className="fs-12px">{data.resume.objective.fasilitator.toFixed(2)}</div>
            </div>
            <div className="d-flex align-items-center mb-2">
              <div className="fw-400 me-2">Training Program</div>
              <div className="progress progress-xs w-100px me-2 ms-auto" style={{ height: "10px" }}>
                <div className="progress-bar progress-bar-striped bg-success" style={{ width: (data.resume.objective.programs / 6) * 100 + "%" }}></div>
              </div>
              <div className="fs-12px">{data.resume.objective.programs.toFixed(2)}</div>
            </div>
            <div className="d-flex align-items-center mb-2">
              <div className="fw-400 me-2">Alat bantu training</div>
              <div className="progress progress-xs w-100px me-2 ms-auto" style={{ height: "10px" }}>
                <div className="progress-bar progress-bar-striped bg-success" style={{ width: (data.resume.objective.tool / 6) * 100 + "%" }}></div>
              </div>
              <div className="fs-12px">{data.resume.objective.tool.toFixed(2)}</div>
            </div>

            <div className="d-flex align-items-center mb-2">
              <div className="fw-400 me-2">Peringkat keseluruhan</div>
              <div className="progress progress-xs w-100px me-2 ms-auto" style={{ height: "10px" }}>
                <div className="progress-bar progress-bar-striped bg-success" style={{ width: (data.resume.objective.overall / 6) * 100 + "%" }}></div>
              </div>
              <div className="fs-12px">{data.resume.objective.overall.toFixed(2)}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function GeneralItem({ dataItem, reloadData }) {
  const [modalEditTitle, setModalEditTitle] = useState({ status: false, data: null });
  const [modalEditLocation, setModalEditLocation] = useState({ status: false, data: null });
  const [modalEditInstitution, setModalEditInstitution] = useState({ status: false, data: null });
  const [modalEditStartDate, setModalEditStartDate] = useState({ status: false, data: null });
  const [modalEditEndDate, setModalEditEndDate] = useState({ status: false, data: null });
  const [modalHelpExtraTimeBtn, setModalHelpExtraTimeBtn] = useState(false);
  const [data, setData] = useState(dataItem);
  function fetchEdit(val) {
    dataTel1EditMain(val).then((res) => {
      if (res.status === "true") {
        reloadData(res.content);
      }
    });
  }
  function handleModalEditTitle(val) {
    setModalEditTitle({ status: true, data: val });
  }
  function handleSaveEditTitle(val) {
    setModalEditTitle((a) => ({ ...a, status: false }));
    fetchEdit(val);
  }
  function handleModalEditLocation(val) {
    setModalEditLocation({ status: true, data: val });
  }
  function handleSaveEditLocation(val) {
    setModalEditLocation((a) => ({ ...a, status: false }));
    fetchEdit(val);
  }
  function handleModalEditInstitution(val) {
    setModalEditInstitution({ status: true, data: val });
  }
  function handleSaveEditInstitution(val) {
    setModalEditInstitution((a) => ({ ...a, status: false }));
    fetchEdit(val);
  }
  function handleModalEditStartDate(val) {
    setModalEditStartDate({ status: true, data: val });
  }
  function handleSaveEditStartDate(val) {
    setModalEditStartDate((a) => ({ ...a, status: false }));
    fetchEdit(val);
  }
  function handleModalEditEndDate(val) {
    setModalEditEndDate({ status: true, data: val });
  }
  function handleSaveEditEndDate(val) {
    setModalEditEndDate((a) => ({ ...a, status: false }));
    fetchEdit(val);
  }
  function handleClickHelpExtraTimeBtn() {
    setModalHelpExtraTimeBtn(true);
  }
  function handleClickExtraBtn() {
    dataTel1ExtraTime({ id: data.id }).then((res) => {
      if (res.status === "true") {
        setData(res.result);
      }
    });
  }
  useEffect(() => setData(dataItem), [dataItem]);
  return (
    <>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">Title</div>
            <div className="text-inverse text-opacity-50">{data.title}</div>
          </div>
          <div className="w-50px text-center">
            <a href="#/" onClick={() => handleModalEditTitle(data)} className="btn btn-outline-default btn-sm">
              <i className="fas fa-edit text-theme"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">Location</div>
            <div className="text-inverse text-opacity-50">{data.location}</div>
          </div>
          <div className="w-50px text-center">
            <a href="#/" onClick={() => handleModalEditLocation(data)} className="btn btn-outline-default btn-sm">
              <i className="fas fa-edit text-theme"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">Institution</div>
            <div className="text-inverse text-opacity-50">{data.institution}</div>
          </div>
          <div className="w-50px text-center">
            <a href="#/" onClick={() => handleModalEditInstitution(data)} className="btn btn-outline-default btn-sm">
              <i className="fas fa-edit text-theme"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">Start Date</div>
            <div className="text-inverse text-opacity-50">{data.startDate}</div>
          </div>
          <div className="w-50px text-center">
            <a href="#/" onClick={() => handleModalEditStartDate(data)} className="btn btn-outline-default btn-sm">
              <i className="fas fa-edit text-theme"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">End Date</div>
            <div className="text-inverse text-opacity-50">{data.endDate}</div>
          </div>
          <div className="w-50px text-center">
            <a href="#/" onClick={() => handleModalEditEndDate(data)} className="btn btn-outline-default btn-sm">
              <i className="fas fa-edit text-theme"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">Created At</div>
            <div className="text-inverse text-opacity-50">{DateTimeFormat(data.createdAt)}</div>
          </div>
        </div>
      </div>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">Created By</div>
            <div className="text-inverse text-opacity-50">{data.createdBy}</div>
          </div>
        </div>
      </div>
      <div className="list-group list-group-flush">
        <div className="list-group-item align-items-center">
          <div className="flex-1 text-break d-flex align-items-center">
            <div className="d-flex align-items-center">
              <div className="text-theme me-1">Valid Until</div>
              {data.extraTimeOcr > 0 ? Array.from({ length: data.extraTimeOcr }, (_, index) => <i key={index} className="fas fa-exclamation-circle text-danger me-1"></i>) : ""}
            </div>
          </div>
          <div className="text-inverse text-opacity-50">{DateTimeFormat(data.validUntil)}</div>
        </div>
      </div>
      <div className="px-3 d-flex align-items-center">
        <button type="button" onClick={handleClickExtraBtn} className="btn btn-outline-warning mb-1 me-1" disabled={data.extraBtn}>
          Extra 5 Minutes
        </button>
        <a href="#/" onClick={handleClickHelpExtraTimeBtn} className="mb-1 px-3" title="Click for help">
          <i className="fas fa-question-circle"></i>
        </a>
      </div>
      <EditTitle show={modalEditTitle.status} submitClick={(val) => handleSaveEditTitle(val)} data={modalEditTitle.data} onHide={() => setModalEditTitle((a) => ({ ...a, status: false }))} />
      <EditLocation show={modalEditLocation.status} submitClick={(val) => handleSaveEditLocation(val)} data={modalEditLocation.data} onHide={() => setModalEditLocation((a) => ({ ...a, status: false }))} />
      <EditInstitution show={modalEditInstitution.status} submitClick={(val) => handleSaveEditInstitution(val)} data={modalEditInstitution.data} onHide={() => setModalEditInstitution((a) => ({ ...a, status: false }))} />
      <EditStartDate show={modalEditStartDate.status} submitClick={(val) => handleSaveEditStartDate(val)} data={modalEditStartDate.data} onHide={() => setModalEditStartDate((a) => ({ ...a, status: false }))} />
      <EditEndDate show={modalEditEndDate.status} submitClick={(val) => handleSaveEditEndDate(val)} data={modalEditEndDate.data} onHide={() => setModalEditEndDate((a) => ({ ...a, status: false }))} />
      <ModalHelp
        show={modalHelpExtraTimeBtn}
        title={"HELP"}
        onHide={() => setModalHelpExtraTimeBtn(false)}
        text={
          "Tombol Extra Time ini berfungsi jika anda memerlukan tambahan waktu 5 menit dari current time (waktu sekarang) agar link aktif kembali.\n Jika link masih aktif tombol extra time ini akan disabled. Tombol ekstra time akan enabled jika link sudah expired.\n [Sings]"
        }
        clicked={() => setModalHelpExtraTimeBtn(false)}
      />
    </>
  );
}
